/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponse } from "@/types/status";

export const API_CONFIG = {
  BASE_URL: "https://api.ophim69.com/api/v1",
  HEADERS: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluIiwiZW1haWwiOiJhZG1pbkBva3ZpcC5jb20iLCJ1c2VyX2lkIjoiNjYwNGRlOGFlNTA2ODA2OWExYmJiNTkyIiwiaWF0IjoxNzU5OTA4OTA5LCJleHAiOjg4MTU5ODIyNTA5fQ.YvpitllZc1knHSV3zL1H0LfXfgvm2_KGmr5ID4NcUjc"}`,
  },
};

export const apiOphim69Client = {
  async request<T = any>(
    method: string,
    endpoint: string,
    data?: any,
    options?: { headers?: Record<string, string> }
  ): Promise<ApiResponse<T>> {
    const url = new URL(`${API_CONFIG.BASE_URL}${endpoint}`);

    const isFormData =
      typeof FormData !== "undefined" && data instanceof FormData;
    const headers = {
      ...API_CONFIG.HEADERS,
      ...(isFormData ? { Accept: "application/json" } : {}),
      ...(options?.headers || {}),
    } as Record<string, string>;

    let body: any | undefined;
    if (data && (method === "POST" || method === "PUT")) {
      if (isFormData) {
        body = data as FormData;
        // For FormData, let browser set Content-Type with boundary
        if (headers["Content-Type"]) {
          delete headers["Content-Type"];
        }
      } else {
        body = JSON.stringify(data);
      }
    } else if (data && method === "GET") {
      Object.keys(data).forEach((key) => {
        if (data[key] !== undefined && data[key] !== null) {
          url.searchParams.append(key, data[key].toString());
        }
      });
    }

    try {
      const response = await fetch(url.toString(), {
        method,
        headers,
        body,
      });

      // Parse JSON response
      const responseData = await response.json().catch(() => ({}));

      return responseData;
    } catch (error: any) {
      // Handle network errors
      return {
        ok: false,
        status: 0,
        statusText: "Lỗi kết nối mạng",
      };
    }
  },

  async get<T = any>(
    endpoint: string,
    params?: Record<string, any>,
    options?: { headers?: Record<string, string> }
  ): Promise<ApiResponse<T>> {
    return this.request("GET", endpoint, params, options);
  },

  async post<T = any>(
    endpoint: string,
    data?: any,
    options?: { headers?: Record<string, string> }
  ): Promise<ApiResponse<T>> {
    return this.request("POST", endpoint, data, options);
  },

  async put<T = any>(
    endpoint: string,
    data?: any,
    options?: { headers?: Record<string, string> }
  ): Promise<ApiResponse<T>> {
    return this.request("PUT", endpoint, data, options);
  },
  async patch<T = any>(
    endpoint: string,
    data?: any,
    options?: { headers?: Record<string, string> }
  ): Promise<ApiResponse<T>> {
    return this.request("PATCH", endpoint, data, options);
  },
  async delete<T = any>(
    endpoint: string,
    options?: { headers?: Record<string, string> }
  ): Promise<ApiResponse<T>> {
    return this.request("DELETE", endpoint, undefined, options);
  },
};
